import styled from 'styled-components';

enum BgColorPalette {
  PRIMARY = 'rgba(48, 48, 48, 1)',
  PRIMARY_HOVER = 'rgba(26, 26, 26, 1)',
  PRIMARY_SHADOW = 'rgba(26, 26, 26, 0.07)',
  PRIMARY_ACTIVE = 'rgba(22, 22, 22, 1)',
  SECONDARY = 'rgba(241, 241, 241, 1)',
  SECONDARY_HOVER = 'rgba(235, 235, 235, 1)',
  SECONDARY_ACTIVE = 'rgba(227, 227, 227, 1)',
  INFO = 'rgba(145, 208, 255, 1)',
  INFO_HOVER = 'rgba(81, 192, 255, 1)',
  INFO_ACTIVE = 'rgba(0, 148, 213, 1)',
  SUCCESS = 'rgba(41, 132, 90, 1)',
  SUCCESS_HOVER = 'rgba(19, 111, 69, 1)',
  SUCCESS_ACTIVE = 'rgba(12, 81, 50, 1)',
  WARNING = 'rgba(255, 184, 0, 1)',
  WARNING_HOVER = 'rgba(178, 132, 0, 1)',
  WARNING_ACTIVE = 'rgba(255, 214, 164, 1)',
  CRITICAL = 'rgba(229, 28, 0, 1)',
  CRITICAL_HOVER = 'rgba(181, 38, 11, 1)',
  CRITICAL_ACTIVE = 'rgba(142, 31, 11, 1)',
  OVERLAY = 'rgba(0, 0, 0, 0.5)',
  FOCUS = '#2c6ecb',
  BADGE_SUCCESS_BG = 'rgba(180, 254, 210, 1)',
  BADGE_INFO_BG = '#d5ebff',
  BADGE_INFO_COLOR = 'rgba(0, 58, 90, 1)',
  BADGE_WARNING_COLOR = 'rgba(94, 66, 0, 1)',
  SUB_TITLE_POLARIS_COLOR = 'rgba(97, 97, 97, 1)',
  RETURN_PAGE_BACKGROUND_COLOR_DEFAULT = '#dddddd',
  SELECTED_TAB_COLOR = '#ebebeb',
  HOVER_TAB_COLOR = '#f1f1f1',
  PROGRESS_INDICATOR_COLOR = '#18a81d',
  MAGIC = '#8051ff',  
  EMPHASIS = '#005bd3',
}

export const StyledSideNavPolarisLayout = styled.div<{
  $navResponsiveWidth: string;
}>`
  display: flex;
  position: sticky;
  top: 10px;

  .page-tabs {
    min-width: 15rem;

    .Polaris-ShadowBevel {
      min-width: 15rem;
    }
  }

  .page-content {
    position: relative;
    min-width: calc(100% - 15rem - 1rem);
    margin-left: 1rem;
  }

    display: block;

    .page-tabs {
      width: 100%;

      .Polaris-ShadowBevel {
        position: relative;
      }
    }

    .page-content {
      margin-left: 0rem;
      margin-top: 1rem;
      min-width: 100%;
    }

  .tabs {
    position: relative;
    &.selected {
      background-color: ${BgColorPalette.SELECTED_TAB_COLOR};
    }
    &.selected > .tabs__label {
      font-weight: 700;
      .tick__icon {
        display: block;
      }
    }
    &:hover {
      background-color: ${BgColorPalette.HOVER_TAB_COLOR};
    }
    display: flex;
    border-radius: 0.5rem;
    padding-inline: 0.5rem 0.25rem;
    padding-block: 0.25rem;
    margin-block: 2px;
    cursor: pointer;

    &__label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: nowrap;
      width: 100%;
      color: #303030;
      font-size: 13px;
      padding-left: 0.5rem;

      .tick__icon {
        display: none;
      }
    }
    .line__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      height: 8px;
      overflow: hidden;
      left: 8px;
      bottom: -3px;
      z-index: 0;
    }
    transition: all 0.5s ease;
  }

  .sub-tabs {
    position: relative;
    &__svg-selected,
    &__svg-hover {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 8px;
      bottom: 1px;
      z-index: 2;
    }

    &__svg-hover {
      display: none;
      z-index: 1;
    }

    &:hover {
      background-color: ${BgColorPalette.HOVER_TAB_COLOR};
    }
    &:hover > .sub-tabs__svg-hover {
      display: flex;
    }
    &.selected {
      background-color: ${BgColorPalette.SELECTED_TAB_COLOR};
    }
    &.selected > .sub-tabs__label {
      font-weight: 700;
      .tick__icon {
        display: block;
      }
    }
    cursor: pointer;
    padding-block: 0.25rem;
    padding-inline: 2.25rem 0.25rem;
    border-radius: 0.5rem;

    &__label {
      font-size: 13px;
      color: #616161;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: nowrap;
      width: 100%;
      .tick__icon {
        display: none;
      }
    }
    transition: all 0.5s ease;
  }

  .Polaris-Icon {
    margin: 0;
  }

  .Polaris-Badge {
        .Polaris-Text--root {
        font-size: 11px;
        }
    }
`;
